/**
 * HowItWorksDiagram.jsx — Iter402-P6
 * -----------------------------------
 * "Paket" → "Subscription" → "Offer" akışını tek ekranda anlatan kompakt
 * SVG+CSS diyagramı. /paketler sayfasında and dashboard'daki onboarding
 * checklist'in yanında embed edilebilir. Backend'siz.
 */
import { Package, Layers, Send, ArrowRight } from 'lucide-react';

export default function HowItWorksDiagram({ compact = false }) {
  const boxClass = compact
    ? 'p-3 text-sm'
    : 'p-4 sm:p-5 text-sm sm:text-base';

  return (
    <div
      className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-6"
      data-testid="how-it-works-diagram"
    >
      <div className="text-center mb-4">
        <h3 className="text-base sm:text-lg font-bold text-emerald-900">How it works?</h3>
        <p className="text-xs sm:text-sm text-slate-600">Reach your first offer in three steps</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr_auto_1fr] items-stretch gap-3">
        {/* Step 1: Paket */}
        <div className={`${boxClass} rounded-xl border-2 border-emerald-200 bg-emerald-50 flex flex-col`}>
          <div className="flex items-center gap-2 mb-2">
            <Package className="w-5 h-5 text-emerald-700" />
            <span className="text-xs font-semibold uppercase tracking-wide text-emerald-700">Step 1</span>
          </div>
          <div className="font-bold text-emerald-900 mb-1">Package</div>
          <p className="text-xs sm:text-sm text-slate-700">
            Defines which roles you can work in (e.g. Service Provider — 200 offers/month).
          </p>
        </div>

        {/* Arrow */}
        <div className="hidden sm:flex items-center justify-center text-slate-400">
          <ArrowRight className="w-6 h-6" />
        </div>

        {/* Step 2: Abonelik */}
        <div className={`${boxClass} rounded-xl border-2 border-amber-200 bg-amber-50 flex flex-col`}>
          <div className="flex items-center gap-2 mb-2">
            <Layers className="w-5 h-5 text-amber-700" />
            <span className="text-xs font-semibold uppercase tracking-wide text-amber-700">Step 2</span>
          </div>
          <div className="font-bold text-amber-900 mb-1">Subscription</div>
          <p className="text-xs sm:text-sm text-slate-700">
            Determines which category requests you will see (e.g. Plumber + Electrician).
          </p>
        </div>

        {/* Arrow */}
        <div className="hidden sm:flex items-center justify-center text-slate-400">
          <ArrowRight className="w-6 h-6" />
        </div>

        {/* Step 3: Offer */}
        <div className={`${boxClass} rounded-xl border-2 border-blue-200 bg-blue-50 flex flex-col`}>
          <div className="flex items-center gap-2 mb-2">
            <Send className="w-5 h-5 text-blue-700" />
            <span className="text-xs font-semibold uppercase tracking-wide text-blue-700">Step 3</span>
          </div>
          <div className="font-bold text-blue-900 mb-1">Make Offer</div>
          <p className="text-xs sm:text-sm text-slate-700">
            Customer chooses → payment → the earnings are yours.
          </p>
        </div>
      </div>

      <p className="text-xs text-slate-500 text-center mt-4">
        <strong>Package</strong> tells you "what you can do"; <strong>subscription</strong> "what you will see".
      </p>
    </div>
  );
}
